import { gsap } from "gsap";

export default class MouseDrag {
	constructor() {
		// this.locomotiveScroll = window.locomotiveScroll
		this.mousePointer = document.querySelector(".mouse-drag");
		this.wrapper = this.mousePointer.closest(".mouse-drag-container") || false;
		this.slider = this.wrapper.querySelector(".flickity-slider") || false;

		this.offsetX = this.mousePointer.getBoundingClientRect().width / 2;
		this.offsetY = this.mousePointer.getBoundingClientRect().height / 2;

		this.init();
		this.events();
	}

	moveCursor(ev) {
		if (ev.target.closest(".slide-info-box")) {
			gsap.to(this.mousePointer, { duration: 0.3, opacity: 0, scale: 0.2 });
		} else {
			gsap.to(this.mousePointer, { duration: 0.3, opacity: 1, scale: 1 });
		}
		// gsap.to(this.mousePointer, {duration: 1, x: ev.clientX})
		this.positionCircle.bind(this, ev)();
	}

	mouseEnter(ev) {
		gsap.to(this.mousePointer, { duration: 0.3, opacity: 1, scale: 1 });
		this.positionCircle.bind(this, ev)();
	}

	mouseLeave(ev) {
		gsap.to(this.mousePointer, { duration: 0.3, opacity: 0, scale: 0.2 });
		this.positionCircle.bind(this, ev)();
	}

	positionCircle(ev) {
		const bannerRect = this.wrapper.getBoundingClientRect();
		const relX = ev.x - bannerRect.x - this.offsetX;
		const relY = ev.y - bannerRect.y - this.offsetY;

		gsap.to(this.mousePointer, { duration: 0.4, x: relX, y: relY });
	}

	// onDragStart(ev) {
	// 	let dragged = ev.target
	// 	console.log(dragged)
	// }

	init() {
		gsap.set(this.mousePointer, { scale: 0 });
	}

	destroy() {
		if (this.slider) {
			this.slider.removeEventListener(
				"mouseenter",
				this.mouseEnter.bind(this),
				false
			);
			this.slider.removeEventListener(
				"mousemove",
				this.moveCursor.bind(this),
				false
			);
			this.slider.removeEventListener(
				"mouseleave",
				this.mouseLeave.bind(this),
				false
			);
		}
	}

	events() {
		if (this.slider) {
			this.slider.addEventListener(
				"mouseenter",
				this.mouseEnter.bind(this),
				false
			);

			this.slider.addEventListener(
				"mousemove",
				this.moveCursor.bind(this),
				false
			);

			this.slider.addEventListener(
				"mouseleave",
				this.mouseLeave.bind(this),
				false
			);

			// this.slider.addEventListener(
			// 	'dragstart',
			// 	this.onDragStart.bind(this),
			// 	false
			// )
		}
	}
}
